export const PILOT_EXPIRED = "Education pilot expired";

// Server detail → localized message; the expired-pilot gate gets its own localized text.
export const eduError = (e, t, fallback) => {
  const d = e?.response?.data?.detail;
  if (d === PILOT_EXPIRED) return t("edu.cls.expiredH");
  return (typeof d === "string" && d) || fallback;
};
